import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BibliographicResourceTypeModule } from '®shared/bibliographic-resource/bibliographic-resource-type.module';

import { CitationPlaceholderComponent } from './citation-placeholder.component';
import { FieldedResourceComponent } from './fielded-resource.component';
import { ItemCitationComponent } from './item-citation.component';

@NgModule({
  imports: [CommonModule, BibliographicResourceTypeModule],
  declarations: [
    CitationPlaceholderComponent,
    FieldedResourceComponent,
    ItemCitationComponent,
  ],
  exports: [
    CitationPlaceholderComponent,
    FieldedResourceComponent,
    ItemCitationComponent,
  ],
})
export class FieldedItemModule {}
